export const SFooterBox = {
  flexGrow: 1,
  justifyContent: "center",
  display: "flex",
  m: '20px',
};
